import React from "react";
import classes from "./cardStratagy.module.css";

const CardStratagy = ({ stratagyTitle }) => {
  return <p className={classes.stratagyTitle}>{stratagyTitle}</p>;
};

export default CardStratagy;
